/* eslint-disable max-lines */
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setGRGRFilter } from '../../../pages/GIGRActivation/actions';
import {
  filterBuilder2,
  rebuildDatesFilter,
} from '../../../utils/builder/aktivasiMyPertamina';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
import { getRegional } from '../../../utils/storage';
import Filter from '../../elements/Filter';
import {
  fetchAgen,
  fetchCities,
  fetchDistricts,
  fetchProvinces,
  fetchRegionals,
  fetchSam,
  fetchSbm,
  fetchVillages,
} from '../../layouts/PageBase/actions';
import { Fields, initialValues } from './fields';
import styles from './styles.scoped.css';

function AreaFilter() {
  // const userData = getUserData();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedTemp, setSelectedTemp] = useState({
    cityId: [],
    districtId: [],
    villageId: [],
  });
  const {
    table: { filter: values },
  } = useSelector((state) => state.gigrActivation);
  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages,
    dataAgents,
    dataDetailUser: {
      regionalId,
      regionalName,
      provinceId,
      cityId,
      cities,
      districtId,
      villageId,
      sam,
      sbm,
    },
  } = useSelector((state) => state.pageBase);

  const userRegion = getRegional();

  const query = queryString.parse(location.search.replace('?', ''));

  const dropdownData = {
    regional: regionalId
      ? [{ label: regionalName, value: regionalId }]
      : [{ value: '', label: 'Semua Regional' }, ...dataRegionals],
    provinces: [{ value: '', label: 'Semua Provinsi' }, ...dataProvinces],
    cities: [{ label: 'Semua Kota/Kab', value: '' }, ...dataCities],
    districts: [{ value: '', label: 'Semua Kecamatan' }, ...dataDistricts],
    villages: [...dataVillages],
    agents: [{ value: '', label: 'Semua Agen' }, ...dataAgents],
  };

  const handleGetAdministrativeArea = (name, params) => {
    if (name === 'agendId') {
      dispatch(fetchAgen());
    }

    const payloadProvince = {
      regional: params?.regional,
      samId: params?.samId,
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId,
      sbmId: params?.sbmId,
    };
    const payloadDistrict = {
      ...payloadCity,
      cityId: params?.cityId,
    };
    const payloadVillage = {
      ...payloadDistrict,
      districtId: params?.districtId,
    };

    if (name === 'regional') {
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      dispatch(fetchSbm(payloadProvince, selectedTemp.sbmId));
      dispatch(fetchSam({ regional: params?.regional }));
    }
    if (name === 'provinceId') {
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'cityId') {
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'districtId') {
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
  };

  const handleGetAgents = (e) => {
    dispatch(fetchAgen(e.target.value));
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if (name === 'regional') {
      filter = {
        ...values,
        regional:
          userRegion ||
          (value !== '*' && value.length > 0 ? JSON.stringify(value) : ''),
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : values.samId,
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : values.sbmId,
      };
    } else if (name === 'provinceId') {
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : values.samId,
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : values.sbmId,
      };
    } else if (name === 'cityId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.cityId.filter((row) => value.includes(row.value)),
        ...dataCities.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'districtId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        villageId: '',
      };
      setSelectedTemp((val) => {
        return {
          ...val,
          districtId: [
            ...val.districtId,
            ...dataDistricts.filter((row) => value.includes(row.value)),
          ],
        };
      });
      const originDataTemp = [
        ...selectedTemp.districtId.filter((row) => value.includes(row.value)),
        ...dataDistricts.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          districtId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'villageId') {
      filter = {
        ...values,
        [name]: value.length > 0 ? JSON.stringify(value) : '',
      };
      const originDataTemp = [
        ...selectedTemp.villageId.filter((row) => value.includes(row.value)),
        ...dataVillages.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          villageId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else {
      filter = { ...values, [name]: value };
    }
    const newQuery = queryString.stringify({
      ...query,
      ...filterBuilder2(filter),
    });

    navigate(`?${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setGRGRFilter(filter));
  };

  const handleReset = () => {
    dispatch(
      setGRGRFilter({
        ...initialValues,
        regional: regionalId ? JSON.stringify([regionalId]) : '',
        provinceId: provinceId,
        cityId: cityId,
        districtId: districtId,
        villageId: villageId || '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : '',
      })
    );
    navigate('?');
  };

  const handleSearchFilter = (value, name) => {
    if (regionalId !== undefined) {
      const payloadProvince = {
        regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
        samId: sam?.id ? JSON.stringify([sam?.id]) : query?.samId,
      };

      const payloadCity = {
        ...payloadProvince,
        provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : query?.sbmId,
        search: value,
      };
      const payloadDistrict = {
        ...payloadCity,
        cityId: query?.cityId?.length > 4 ? query?.cityId : '',
      };
      const payloadVillage = {
        ...payloadDistrict,
        districtId: query?.districtId?.length > 4 ? query?.districtId : '',
      };
      if (name === 'cities') {
        dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      }
      if (name === 'districts') {
        dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      }
      if (name === 'villages') {
        dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      }
    }
  };

  useEffect(() => {
    if (regionalId !== undefined) {
      dispatch(fetchRegionals());
      dispatch(fetchAgen());
      const newQuery = rebuildDatesFilter({
        regional: regionalId ? JSON.stringify([regionalId]) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
      });
      dispatch(setGRGRFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, [regionalId]);

  return (
    <Filter
      className={styles.gigrFields}
      fields={Fields({
        values,
        handleChangeValues,
        handleGetAgents,
        dropdownData,
        regionalId,
        provinceId,
        cities,
        cityId,
        handleSearchFilter,
      })}
      handleReset={handleReset}
    />
  );
}

export default AreaFilter;
